var path = 'areas/shared/views/not-found.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li>Not Found</li> </script> <p>Sorry, the page you are looking for could not be found.</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/not-found.html
// module id = 735267649275735
// module chunks = 1